// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * IMS Management API
 * Management API for the IMS catalog: partitions, isolation units, and clusters, returned in a Kubernetes-familiar metadata/spec/status envelope (ADR-0008).
 *
 * The version of the OpenAPI document: 1.0
 * Contact: team-aura-infra@neotechnology.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface PartitionSpecInput
 */
export interface PartitionSpecInput {
  /**
   *
   * @type {string}
   * @memberof PartitionSpecInput
   */
  cloudProvider?: string;
  /**
   *
   * @type {string}
   * @memberof PartitionSpecInput
   */
  mode?: string;
  /**
   *
   * @type {string}
   * @memberof PartitionSpecInput
   */
  partitionAlias?: string;
  /**
   *
   * @type {string}
   * @memberof PartitionSpecInput
   */
  plane?: string;
  /**
   *
   * @type {string}
   * @memberof PartitionSpecInput
   */
  region?: string;
  /**
   *
   * @type {string}
   * @memberof PartitionSpecInput
   */
  scope?: string;
  /**
   *
   * @type {object}
   * @memberof PartitionSpecInput
   */
  topology?: object;
}

/**
 * Check if a given object implements the PartitionSpecInput interface.
 */
export function instanceOfPartitionSpecInput(
  value: object,
): value is PartitionSpecInput {
  return true;
}

export function PartitionSpecInputFromJSON(json: any): PartitionSpecInput {
  return PartitionSpecInputFromJSONTyped(json, false);
}

export function PartitionSpecInputFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PartitionSpecInput {
  if (json == null) {
    return json;
  }
  return {
    cloudProvider:
      json['cloud_provider'] == null ? undefined : json['cloud_provider'],
    mode: json['mode'] == null ? undefined : json['mode'],
    partitionAlias:
      json['partition_alias'] == null ? undefined : json['partition_alias'],
    plane: json['plane'] == null ? undefined : json['plane'],
    region: json['region'] == null ? undefined : json['region'],
    scope: json['scope'] == null ? undefined : json['scope'],
    topology: json['topology'] == null ? undefined : json['topology'],
  };
}

export function PartitionSpecInputToJSON(json: any): PartitionSpecInput {
  return PartitionSpecInputToJSONTyped(json, false);
}

export function PartitionSpecInputToJSONTyped(
  value?: PartitionSpecInput | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    cloud_provider: value['cloudProvider'],
    mode: value['mode'],
    partition_alias: value['partitionAlias'],
    plane: value['plane'],
    region: value['region'],
    scope: value['scope'],
    topology: value['topology'],
  };
}
